import { useIntl } from 'react-intl';
import type { ReactElement } from 'react';

function Error500(): ReactElement {
  const { formatMessage: f } = useIntl();
  return (
    <div
      className="flex h-[calc(100vh-60px)] -mt-8 items-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/assets/bg-error-500.jpg')" }}
    >
      <div className="mx-auto max-w-[500px] rounded bg-bg-default shadow-[0_0_8px_rgba(0,0,0,0.04),0_8px_8px_rgba(0,0,0,0.08)]">
        <div className="p-6">
          <h3 className="mb-8 text-2xl font-bold text-brand-primary">
            {f({ id: 'error500.title' })}
          </h3>
          <h4 className="mb-4 text-base font-bold">{f({ id: 'error500.subtitle' })}</h4>
        </div>

        <div className="border-t border-border-disabled px-4 py-3 text-right">
          <a href="/" className="e-button e-button--gray">
            {f({ id: 'error500.back' })}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Error500;
